export const Props = () => ({
  //Тип кнопки (default, start)
  type: {
    type: String,
    default: 'default',
    validator: (value) => {
      const allowedTypes = ['default', 'start'];
      if(allowedTypes.includes(value)){
        return true;
      } else{
        throw new Error(`Параметр 'type' в компоненте ButtonLegend может содержать только значения: ${allowedTypes.join(', ')}`);
      }
    }
  },
});